import { render, staticRenderFns } from "./AdminTrafficTicket.vue?vue&type=template&id=9929f5e8&"
import script from "./AdminTrafficTicket.vue?vue&type=script&lang=js&"
export * from "./AdminTrafficTicket.vue?vue&type=script&lang=js&"
import style0 from "./AdminTrafficTicket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports